import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FocusInputType, KeyValueId, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-text-update',
  templateUrl: './text-update.component.html',
  styleUrl: './text-update.component.scss'
})
export class TextUpdateComponent {
  @Input() key: string = '';
  @Input() header: string = '';
  @Input() value: string = '';
  @Input() placeHolder: string = 'Enter here..';
  @Input() isReadOnly: boolean = false;

  @Input() isOpen: boolean = false;
  @Output() isOpenChange = new EventEmitter();
  @Output() onSave = new EventEmitter();

  elementIds: any = {
    txt_update: 'txt-update'
  };

  constructor(public localService: LocalService) { }

  ngOnChanges(): void {
    this.localService.onFocusNextInput(this.elementIds.txt_update, FocusInputType.TextBox);
  }

  close() {
    this.isOpen = false;
    this.isOpenChange.emit(this.isOpen);
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.close();
      } break;
      case 2: {
        this.onSave.emit({ key: this.key, value: this.value.trim() } as KeyValueId);
        this.close();
      } break;
    }
  }
}
